import * as React from 'react';
import { clsx } from 'clsx';
import { useGetIsMobileDevice } from '../../hooks';
import * as styles from './RightAdornment.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const RightAdornmentComponent = props => {
  const {
    hasButtons,
    hasBothControls
  } = props;
  const isMobileDevice = useGetIsMobileDevice();
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['right-adornment'], hasButtons && styles['has-buttons'], hasBothControls && styles['has-all-controls'], isMobileDevice && styles['mobile']),
    children: props.children
  });
};
export const RightAdornment = /*#__PURE__*/React.memo(RightAdornmentComponent);